export default __webpack_public_path__ + "static/media/DTV-Flyers-1.62cbf63a.jpeg";